module.exports = __webpack_public_path__ + "img/63.b6fb9bc7.jpg";